import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { customerApi } from "@/lib/api";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("customer_token");
    if (!token) { setReady(true); return; }
    customerApi.get("/auth/me")
      .then((r) => setCustomer(r.data.customer))
      .catch(() => localStorage.removeItem("customer_token"))
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await customerApi.post("/auth/login", { email, password });
    localStorage.setItem("customer_token", data.token);
    setCustomer(data.customer);
    return data.customer;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await customerApi.post("/auth/register", payload);
    localStorage.setItem("customer_token", data.token);
    setCustomer(data.customer);
    return data.customer;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("customer_token");
    setCustomer(null);
  }, []);

  return (
    <CustomerAuthContext.Provider value={{ customer, ready, login, register, logout }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export function useCustomerAuth() {
  const ctx = useContext(CustomerAuthContext);
  if (!ctx) throw new Error("useCustomerAuth must be used within CustomerAuthProvider");
  return ctx;
}
